enum TickSizeType {
  Default = "Default",
  Fixed = "Fixed",
}

export default TickSizeType;
